export default __webpack_public_path__ + "static/src/assets/images/icons/loginids.png";